import { render, staticRenderFns } from "./uf_sub_industry_id.vue?vue&type=template&id=1fda7156&scoped=true"
import script from "./uf_sub_industry_id.vue?vue&type=script&lang=js"
export * from "./uf_sub_industry_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda7156",
  null
  
)

export default component.exports